<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <order-search :status-text="statusText" :params.sync="queryParams" :show-supplier="false" :order-count="orderCount" @filter="handleFilter" />
      </template>

      <order-table :list="list" is-refund />
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import OrderTable from '@/components/Order/order-table'
import OrderSearch from '@/components/Order/order-search'
import { getRefundCount, getRefundList } from '@/api/order'

export default {
  name: 'RefundOrderList',
  components: {
    Pagination,
    OrderTable,
    OrderSearch
  },
  data() {
    return {
      list: null,
      total: 0,
      loading: false,
      queryParams: {
        keyword: '', // 关键词（用户昵称、手机号、分享码）
        dateRange: '', // 下单日期范围
        orderNumber: '',
        orderStatus: '0',
        orderType: '', // 优品商城订单
        payNumber: '',
        logisticsNumber: '',
        dateStart: '',
        dateEnd: '',
        consigneeInfo: '',
        page: 1,
        limit: 20
      },
      statusText: [],
      orderCount: {
        all: 0,
        apply: 0,
        refunding: 0,
        refunded: 0,
        rejected: 0
      }
    }
  },
  created() {
    this.statusText = [
      { id: '0', text: '全部', field: 'all', value: 0 },
      { id: '1', text: '申请中', field: 'apply', value: 0 },
      { id: '2', text: '退款中', field: 'refunding', value: 0 },
      { id: '3', text: '已退款', field: 'refunded', value: 0 },
      { id: '4', text: '已拒绝', field: 'rejected', value: 0 }
    ]
    this.fetchData()
  },
  methods: {
    fetchData(action = '') {
      this.loading = true
      const params = Object.assign({}, this.queryParams, { refundStatus: this.queryParams.orderStatus })
      if (params.dateStart) params.dateStart += ' 00:00:00'
      if (params.dateEnd) params.dateEnd += ' 23:59:59'
      Promise.all([getRefundCount(params), getRefundList(params)]).then(([counts, refunds]) => {
        this.orderCount = counts
        this.list = refunds.records
        this.total = refunds.total
      }).catch(() => {}).finally(() => {
        this.$util.delay().then(() => { this.loading = false })
      })
    },
    handleFilter(evt) {
      this.queryParams.page = 1
      this.fetchData(evt.action)
    }
  }
}
</script>
